export var languagesList = [
    'en',
    'de',
    'uk',
    'pl',
    'nl',
    'tr',
    'fr',
    'es',
    'pt',
    'ru',
];
export var ENGLISH = 'en';
export var GERMAN = 'de';
